// React hooks used for local workflow list state and memoized fetch callback.
import { useCallback, useState } from "react";

// API call used to load available AI workflows for the current user.
import { getAIWorkflows } from "api/APIStrichCalls";



const useWorkflowList = (token) => {

  // Keep the latest workflows returned by the API for rendering and selection.
  // List of workflows shown in workflow panel.
  const [workflows, setWorkflows] = useState([]);

  // Load workflows from API and keep local state in sync.
  const fetchWorkflows = useCallback(async () => {

    try {

      // Request all available AI workflows for this user/token.
      const response = await getAIWorkflows(token);

      // API returns workflows in response.results.
      const nextWorkflows = response.results || [];

      // Save list for UI rendering.
      setWorkflows(nextWorkflows);
    
      return nextWorkflows;
    
    } catch (error) {

      console.error("Error fetching AI workflows:", error);

      // On failure, clear list so UI does not show stale data.
      setWorkflows([]);

      return [];

    }

  }, [token]);

  // Expose workflows data and a manual refresh function to the page.
  return {

    workflows,
    fetchWorkflows,

  };

};

export default useWorkflowList;
